<template>
<div class="rewards-table">
  <div class="rt-heading">
    <div class="rt-h-col">Campaign</div>
    <div class="rt-h-col">Reward Name</div>
    <div class="rt-h-col">Customer Email</div>
    <div class="rt-h-col">Earned Date</div>
    <div class="rt-h-col">Reward Code</div>
    <div class="rt-h-col">Use Date</div>
    <div class="rt-h-col">Action</div>
  </div>
  <div class="rt-top-body">
    <div class="rt-body" v-if="result.length > 0" v-for="(item, index) in result" :key="index">
      <div class="rt-b-col"><h4>{{ item.post.name }}</h4></div>
      <div class="rt-b-col"><h4>{{ item.prize.name }}</h4></div>
      <div class="rt-b-col"><h4 >{{ item.email }}</h4></div>
      <div class="rt-b-col">{{ item.earned_date ? item.earned_date : 'No record' }}</div>
      <div class="rt-b-col">{{ item.prize.code }}</div>
      <div class="rt-b-col">{{ item.expire_date ? expireDate(item.expire_date) : 'No record' }}</div>
  <!--    <div class="rt-b-col"><div class="al-button">Send Reminder</div></div>-->
    </div>
  </div>

  <send-reminder-popup v-if="showPopup" :updated="SendReminderResult" />
</div>
</template>

<script>

import SendReminderPopup from './SendReminderPopup.vue'
import moment from 'moment'

export default {
  name: 'EarnedRewards',
  components: {
    SendReminderPopup
  },
  data () {
    return {
      showPopup: false,
      result: []
    }
  },
  mounted () {
    this.getRewards()
  },
  methods: {
    handleList (list) {
      const result_list = list
      list.map((item) => {
        const result_item = JSON.parse(JSON.stringify(item))
        console.log('interaction item', result_item)
        if (!result_item.prize.registered && result_item.is_played) {
          console.log('not registered and played')
          const prize_item = result_item
          prize_item.code = `${result_item.prize.code}scratch`
          prize_item.earned_date = result_item.prize.earned_date
          prize_item.expire_date = result_item.prize.expire_date
        }
      })
      return result_list.reverse()
    },
    expireDate (str) {
      return moment(str).format('MM/DD/YYYY')
    },
    formatDate (str) {
      const date = str.split('T')[0]
      const values = date.split('-')
      const day = values[2]
      const month = values[1]
      const year = values[0]
      return `${month}/${day}/${year}`
    },
    SendReminderResult () {
      this.showPopup = false
    },
    getRewards () {
      const payload = {
        type: 'earned'
      }
      this.$store.dispatch('getRewardsList', payload)
        .then((response) => {
          console.log('success', response)
          this.result = this.handleList(response.data.data)
        })
        .catch(error => {
          console.log('error', error)
        })
    }
  }
}
</script>
